<template>
  <div>
    <div v-for="domainObject in domainObjects" :key="domainObject.type">
      <b-dropdown
        v-if="domainObject.visible"
        :id="domainObject.type"
        variant="primary"
        :text="t(
          domainObject.type === 'email' &&
            custom.nonWhitelistedEmailAddressesAllowed
            ? 'emailNonWhitelisted'
            : domainObject.type + 'Text'
        )
        ">
        <b-dropdown-item-button v-for="domain in domainObject.domains" :key="domain">
          {{ domain.name }}
        </b-dropdown-item-button>
      </b-dropdown>

      <template v-if="domainObject.visible && loadingValidDomains">
        <div class="spinner-border spinner-border-sm"></div>
      </template>
    </div>
  </div>
</template>

<i18n>
  en:
    emailNonWhitelisted: "Email addresses with domain names from this list can be used without further confirmation. Email addresses with all other domain names must be confirmed separately."
    emailText: "You can use the following domain names in email addresses:"
    serverText: "You can use the following domain names in the CN attribute and SubjectAlternativeNames of type 'DNS':"
  de:
    emailNonWhitelisted: "E-Mail-Adressen mit folgenden Domainnamen können ohne weitere Bestätigung verwendet werden. E-Mail-Adressen mit anderen Domainnamen müssen separat bestätigt werden."
    emailText: "Die folgenden Domainnamen können Sie in E-Mail-Adressen nutzen:"
    serverText: "Die folgenden Domainnamen können Sie im CN-Attribut und in SubjectAlternativeNames (SaN) des Typs 'DNS' nutzen:"
</i18n>

<script setup>
import { reactive, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

import { custom } from "@/customization/customization";
import { Logger } from "@/logger/logger";
import { DFNSOAPClient } from "@/soap/dfnsoapclient";

const { t } = useI18n()

const logger = new Logger("DomainDropdown");

const props = defineProps({
  email: { type: Boolean, default: false },
  server: { type: Boolean, default: false },
})

const loadingValidDomains = ref(false);
const domainObjects = reactive([
  { type: "email", visible: props.email, domains: [] },
  { type: "server", visible: props.server, domains: [] },
])

onMounted(() => {
  getValidDomains();
})

const getValidDomains = async () => {
  /**
   * Lädt die möglichen Email oder Server Domains, abhängig davon welcher
   * Zertifikattyp ausgewählt ist
   */
  const client = new DFNSOAPClient(custom.pubURL, custom.ra_id);
  for (let domainObject of domainObjects) {
    if (!domainObject.visible) continue;
    logger.debug(
      "getValidDomains(): hole Domains vom Typ " + domainObject.type
    );
    loadingValidDomains.value = true;
    try {
      domainObject.domains = await client.getValidDomains(
        domainObject.type
      );
    } catch (exception) {
      logger.error(
        "Fehler beim Ermitteln der gültigen Domains: " + exception
      );
    }
  }
  loadingValidDomains.value = false;
}
</script>

<style scoped>
#email,
#server {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
